export default __webpack_public_path__ + "static/media/Updates.9ea96116.jpeg";